'use client';

import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import WholesaleHero from './WholesaleHero';
import BenefitsSection from './BenefitsSection';
import WholesaleForm from './WholesaleForm';
import TestimonialsSection from './TestimonialsSection';
import FAQSection from './FAQSection';
import CTASection from './CTASection';

interface Benefit {
  icon: string;
  title: string;
  description: string;
}

interface Testimonial {
  name: string;
  company: string;
  role: string;
  image: string;
  alt: string;
  rating: number;
  text: string;
}

interface FAQ {
  question: string;
  answer: string;
}

interface WholesaleInteractiveProps {
  benefits: Benefit[];
  testimonials: Testimonial[];
  faqs: FAQ[];
}

const WholesaleInteractive: React.FC<WholesaleInteractiveProps> = ({
  benefits,
  testimonials,
  faqs
}) => {
  const { t } = useLanguage();
  
  return (
    <>
      <WholesaleHero data-component-id="src/app/wholesale/components/WholesaleInteractive.tsx:48:6" data-component-path="src/app/wholesale/components/WholesaleInteractive.tsx" data-component-line="48" data-component-file="WholesaleInteractive.tsx" data-component-name="WholesaleHero" data-component-content="%7B%22elementName%22%3A%22WholesaleHero%22%7D"
        title={t('wholesale.hero.title')}
        subtitle={t('wholesale.hero.subtitle')}
      />
      <BenefitsSection data-component-id="src/app/wholesale/components/WholesaleInteractive.tsx:52:6" data-component-path="src/app/wholesale/components/WholesaleInteractive.tsx" data-component-line="52" data-component-file="WholesaleInteractive.tsx" data-component-name="BenefitsSection" data-component-content="%7B%22elementName%22%3A%22BenefitsSection%22%7D" benefits={benefits} />
      <WholesaleForm data-component-id="src/app/wholesale/components/WholesaleInteractive.tsx:53:6" data-component-path="src/app/wholesale/components/WholesaleInteractive.tsx" data-component-line="53" data-component-file="WholesaleInteractive.tsx" data-component-name="WholesaleForm" data-component-content="%7B%22elementName%22%3A%22WholesaleForm%22%7D" />
      <TestimonialsSection data-component-id="src/app/wholesale/components/WholesaleInteractive.tsx:54:6" data-component-path="src/app/wholesale/components/WholesaleInteractive.tsx" data-component-line="54" data-component-file="WholesaleInteractive.tsx" data-component-name="TestimonialsSection" data-component-content="%7B%22elementName%22%3A%22TestimonialsSection%22%7D" testimonials={testimonials} />
      <FAQSection data-component-id="src/app/wholesale/components/WholesaleInteractive.tsx:55:6" data-component-path="src/app/wholesale/components/WholesaleInteractive.tsx" data-component-line="55" data-component-file="WholesaleInteractive.tsx" data-component-name="FAQSection" data-component-content="%7B%22elementName%22%3A%22FAQSection%22%7D" faqs={faqs} />
      <CTASection data-component-id="src/app/wholesale/components/WholesaleInteractive.tsx:56:6" data-component-path="src/app/wholesale/components/WholesaleInteractive.tsx" data-component-line="56" data-component-file="WholesaleInteractive.tsx" data-component-name="CTASection" data-component-content="%7B%22elementName%22%3A%22CTASection%22%7D" />
    </>
  );
};

export default WholesaleInteractive;